import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IEmotionsClientSelection {
  participantIdentity: string;
  category: string[];
  emo: string[];
}

/** Данные об «общем экране» — эмоции участника, которого психолог сейчас просматривает */
export interface IEmotionsSharedView {
  participantLabel: string;
  emo: string[];
}

export interface IEmotionsGroupState {
  /** Выборы эмоций по участникам для психолога (групповая терапия) */
  clientSelectionsByParticipant: Record<string, { category: string[]; emo: string[] }>;
  /** Эмоции, транслируемые психологом на «общий экран» (для клиентов в групповой терапии) */
  sharedView: IEmotionsSharedView | null;
}

const initialState: IEmotionsGroupState = {
  clientSelectionsByParticipant: {},
  sharedView: null,
};

export const emotionsGroupSlice = createSlice({
  name: 'emotionsGroupState',
  initialState,
  reducers: {
    setEmotionsClientSelection: (state, action: PayloadAction<IEmotionsClientSelection>) => {
      const { participantIdentity, category, emo } = action.payload;
      state.clientSelectionsByParticipant[participantIdentity] = { category, emo };
    },
    clearEmotionsClientSelections: (state) => {
      state.clientSelectionsByParticipant = {};
    },
    setEmotionsSharedView: (state, action: PayloadAction<IEmotionsSharedView>) => {
      state.sharedView = action.payload;
    },
    clearEmotionsSharedView: (state) => {
      state.sharedView = null;
    },
  },
});

export const {
  setEmotionsClientSelection,
  clearEmotionsClientSelections,
  setEmotionsSharedView,
  clearEmotionsSharedView,
} = emotionsGroupSlice.actions;
export default emotionsGroupSlice.reducer;
